<template>
  <!-- Contenedor -->
  <v-container fluid>
    <!-- Snackbar -->
    <SnackbarMessage ref="snackbar" />
    <!-- Sección para los ajustes del usuario -->
    <v-flex xs12>
      <DeltiaCard>
        <!-- Subtítulo -->
        <v-col cols="12">
          <p class="font-weight-medium mb-1">
            Perfil
          </p>
        </v-col>

        <!-- Nombre del usuario -->
        <v-col cols="12" class="headline font-weight-bold text--primary pb-0">
          {{ getProfile.name }}
        </v-col>
        <!-- Email -->
        <v-col cols="12" class="subtitle-1 pt-0">
          {{ getProfile.email }}
        </v-col>
        <!-- Acciones -->
        <v-col cols="12" class="mt-4 mb-6">
          <!-- Botón para cerrar sesión -->
          <v-btn rounded depressed color="error" @click="signOut">
            Cerrar sesión
          </v-btn>
        </v-col>
      </DeltiaCard>
    </v-flex>
    <!-- Sección para recargar la página -->
    <v-flex xs12>
      <DeltiaCard>
        <!-- Subtítulo -->
        <v-col cols="12">
          <p class="font-weight-medium mb-1">
            Recargar la página
          </p>
        </v-col>
        <!-- Descripción -->
        <v-col cols="12" class="subtitle-1 pt-0">
          Esto sirve para otener los últimos cambios de la página
        </v-col>
        <!-- Acciones -->
        <v-col cols="12" class="mt-4 mb-6">
          <!-- Botón para cerrar sesión -->
          <v-btn rounded depressed color="primary" @click="refresh">
            Recargar
          </v-btn>
        </v-col>
      </DeltiaCard>
    </v-flex>
    <!-- Sección de pagos de Stripe -->
    <v-flex
      v-if="
        !getProfile.stripe.pending_verification &&
          getProfile.stripe.details_submitted &&
          balance &&
          getProfile.testing_orders
      "
      xs12
    >
      <DeltiaCard class="pb-6">
        <!-- Subtítulo -->
        <v-col cols="12">
          <p class="font-weight-medium mb-1">
            Pagos
          </p>
        </v-col>
        <!-- Mostrar saldo -->
        <v-col cols="12" class="subtitle-1 mt-0 pt-0 pb-0">
          Saldo pendiente: ${{ pendingTotal | formatNumber }}
        </v-col>
        <v-col cols="12" class="subtitle-1 mt-0 pt-0 pb-0">
          Saldo disponible: ${{ availableTotal | formatNumber }}
        </v-col>
      </DeltiaCard>
    </v-flex>
    <!-- Formulario de facturación -->
    <v-flex v-if="showBilling && !billingInfo" xs12>
      <DeltiaCard>
        <!-- Subtítulo -->
        <v-col cols="12">
          <p class="font-weight-medium mb-1">
            Facturación
          </p>
        </v-col>
        <!-- Descripción -->
        <v-col cols="12" class="subtitle-1 pt-0">
          Habilita la facturación en tu organización rellenando la siguiente
          información.
        </v-col>
        <!-- Formulario: nombre, nombre legal, tax system (dropdown), address, website, support email, phone -->
        <v-col cols="12" class="mt-4 mb-6">
          <v-form>
            <v-row xs12>
              <!-- Nombre -->
              <v-col class="pt-0 pb-0" cols="12" md="6">
                <v-text-field
                  filled
                  color="secondary"
                  rounded
                  auto-grow
                  hide-details="auto"
                  name="input-7-4"
                  label="Nombre"
                  v-model="billingForm.name"
                ></v-text-field>
              </v-col>
              <!-- Nombre legal -->
              <v-col class="pt-0 pb-0" cols="12" md="6">
                <v-text-field
                  filled
                  color="secondary"
                  rounded
                  auto-grow
                  hide-details="auto"
                  name="input-7-4"
                  label="Razón social, sin el régimen societario (ej.: S.A. de C.V.)."
                  v-model="billingForm.legalName"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Tax system -->
            <v-select
              filled
              color="secondary"
              rounded
              auto-grow
              hide-details="auto"
              name="input-7-4"
              label="Régimen fiscal"
              class="mt-4"
              :items="getTaxSystems()"
              item-text="value"
              item-value="key"
              v-model="billingForm.taxSystem"
            ></v-select>
            <br />
            <!-- Dirección -->
            <v-row xs12 class="mt-4">
              <!-- Calle -->
              <v-col class="pt-0 pb-0" cols="12" md="3">
                <v-text-field
                  filled
                  color="secondary"
                  rounded
                  auto-grow
                  hide-details="auto"
                  name="input-7-4"
                  label="Calle"
                  class="mt-4"
                  v-model="billingForm.address.street"
                />
              </v-col>
              <!-- Número exterior -->
              <v-col class="pt-0 pb-0" cols="12" md="3">
                <v-text-field
                  filled
                  color="secondary"
                  rounded
                  auto-grow
                  hide-details="auto"
                  name="input-7-4"
                  label="Número exterior"
                  class="mt-4"
                  v-model="billingForm.address.exterior"
                />
              </v-col>
              <!-- Número interior -->
              <v-col class="pt-0 pb-0" cols="12" md="3">
                <v-text-field
                  filled
                  color="secondary"
                  rounded
                  auto-grow
                  hide-details="auto"
                  name="input-7-4"
                  label="Número interior (opcional)"
                  class="mt-4"
                  v-model="billingForm.address.interior"
                />
              </v-col>
              <!-- Colonia -->
              <v-col class="pt-0 pb-0" cols="12" md="3">
                <v-text-field
                  filled
                  color="secondary"
                  rounded
                  auto-grow
                  hide-details="auto"
                  name="input-7-4"
                  label="Colonia"
                  class="mt-4"
                  v-model="billingForm.address.neighborhood"
                />
              </v-col>
            </v-row>
            <v-row xs12 class="mt-4">
              <!-- Código postal -->
              <v-col class="pt-0 pb-0" cols="12" md="4">
                <v-text-field
                  filled
                  color="secondary"
                  rounded
                  auto-grow
                  hide-details="auto"
                  name="input-7-4"
                  label="Código postal"
                  v-model="billingForm.address.zip"
                ></v-text-field>
              </v-col>
              <!-- Estado -->
              <v-col class="pt-0 pb-0" cols="12" md="4">
                <v-select
                  filled
                  color="secondary"
                  rounded
                  auto-grow
                  hide-details="auto"
                  name="input-7-4"
                  label="Estado"
                  :items="getStates()"
                  item-text="label"
                  item-value="label"
                  v-model="billingForm.address.state"
                ></v-select>
              </v-col>
              <!-- Ciudad -->
              <v-col class="pt-0 pb-0" cols="12" md="4">
                <v-text-field
                  filled
                  color="secondary"
                  rounded
                  auto-grow
                  hide-details="auto"
                  name="input-7-4"
                  label="Ciudad"
                  v-model="billingForm.address.city"
                />
              </v-col>
            </v-row>
            <br />
            <!-- Sitio web -->
            <v-text-field
              filled
              color="secondary"
              rounded
              auto-grow
              hide-details="auto"
              name="input-7-4"
              label="Sitio web (opcional)"
              class="mt-4"
              v-model="billingForm.website"
            ></v-text-field>
            <!-- Correo de soporte -->
            <v-text-field
              filled
              color="secondary"
              rounded
              auto-grow
              hide-details="auto"
              name="input-7-4"
              label="Correo electrónico de soporte"
              class="mt-4"
              v-model="billingForm.supportEmail"
            ></v-text-field>
            <!-- Teléfono -->
            <v-text-field
              filled
              color="secondary"
              rounded
              auto-grow
              hide-details="auto"
              name="input-7-4"
              label="Teléfono"
              class="mt-4"
              v-model="billingForm.phone"
            ></v-text-field>
          </v-form>
        </v-col>
        <!-- Save button -->
        <v-col cols="12" class="mt-4 mb-6 text-left">
          <v-btn
            :loading="isConfiguringBilling"
            rounded
            depressed
            color="primary"
            @click="configureBilling"
            :disabled="!canConfigureBilling"
          >
            Comenzar
          </v-btn>
        </v-col>
      </DeltiaCard>
    </v-flex>
    <!-- Subir certificados -->
    <v-flex
      v-if="showBilling && billingInfo && billingInfo.pending_steps.length > 0"
    >
      <DeltiaCard>
        <!-- Subtítulo -->
        <v-col cols="12">
          <p class="font-weight-medium mb-1">
            Facturación
          </p>
        </v-col>
        <!-- Descripción -->
        <v-col cols="12" class="subtitle-1 pt-0">
          Sube tu Certificado de Sello Digital (CSD)
        </v-col>
        <!-- Formulario -->
        <v-col cols="12" class="mt-4 mb-6">
          <v-form
            @submit.prevent="uploadCert"
            enctype="multipart/form-data"
            ref="form"
          >
            <!-- .cer file -->
            <v-file-input
              filled
              color="secondary"
              rounded
              auto-grow
              hide-details="auto"
              name="input-7-4"
              label="Archivo con extensión .cer"
              class="mt-4"
              v-model="billingCertForm.cer"
            />
            <!-- .key file -->
            <v-file-input
              filled
              color="secondary"
              rounded
              auto-grow
              hide-details="auto"
              name="input-7-4"
              label="Archivo con extensión .key"
              class="mt-4"
              v-model="billingCertForm.key"
            />
            <!-- Password -->
            <v-text-field
              filled
              color="secondary"
              rounded
              auto-grow
              hide-details="auto"
              name="input-7-4"
              label="Contraseña del certificado"
              class="mt-4"
              v-model="billingCertForm.billingPassword"
            />
            <!-- Save button -->
            <v-btn
              :loading="isUploadingCert"
              rounded
              depressed
              color="primary"
              class="mt-4"
              type="submit"
            >
              Subir archivos
            </v-btn>
          </v-form>
        </v-col>
      </DeltiaCard>
    </v-flex>
    <!-- Información actualizada -->
    <v-flex
      v-if="
        showBilling && billingInfo && billingInfo.pending_steps.length === 0
      "
    >
      <DeltiaCard>
        <!-- Subtítulo -->
        <v-col cols="12">
          <p class="font-weight-medium mb-1">
            Facturación
          </p>
        </v-col>
        <!-- Descripción -->
        <v-col cols="12" class="subtitle-1 pt-0 mb-6">
          La facturación se configuró correctamente
        </v-col>
      </DeltiaCard>
    </v-flex>
    <!-- Sección para pagos de MercadoPago -->
    <v-flex v-if="getProfile.testing_orders" xs12>
      <DeltiaCard>
        <!-- Subtítulo -->
        <v-col cols="12">
          <p class="font-weight-medium mb-1">
            Pagos
          </p>
        </v-col>
        <v-col v-if="!getProfile.mercadopago" class="mb-4">
          Para recibir pagos de tus clientes en Deltia debes conectar tu cuenta
          con MercadoPago
        </v-col>
        <v-col v-else class="mb-4">
          MercadoPago ya está configurado
        </v-col>
        <!-- Acciones -->
        <v-col v-if="!getProfile.mercadopago" cols="12" class="mt-4 mb-6">
          <!-- Botón para comenzar a recibir pagos -->
          <v-btn
            rounded
            depressed
            color="secondary"
            @click="$router.push({ name: 'mercadopago' })"
          >
            Ir a ajustes de pagos
          </v-btn>
        </v-col>
      </DeltiaCard>
    </v-flex>
    <!-- Mensaje de agradecimiento -->
    <v-flex v-if="getProfile.testing_orders" xs12>
      <DeltiaCard class="pb-6">
        <!-- Subtítulo -->
        <v-col cols="12">
          <p class="font-weight-medium mb-1">
            Nota de agradecimiento
          </p>
        </v-col>
        <v-col cols="12" class="subtitle-1 mt-0 pt-0 mb-0 pb-0">
          Esto se le mostrará a tus clientes cuando completen una compra
        </v-col>
        <!-- Área de texto -->
        <v-col cols="12" class="subtitle-1 mt-0 pt-0 pb-0">
          <v-textarea
            v-model="newThankYouNote"
            filled
            color="secondary"
            rounded
            auto-grow
            hide-details="auto"
            name="input-7-4"
            label="¿Qué te gustaría decirle a tus clientes?"
          ></v-textarea>
        </v-col>
        <!-- Botón de guardar -->
        <v-col cols="12" class="mt-2">
          <v-btn
            @click="updateThankYouNote"
            :disabled="thankYouNote === newThankYouNote"
            color="primary"
            depressed
            rounded
          >
            Guardar
          </v-btn>
        </v-col>
      </DeltiaCard>
    </v-flex>
    <!-- Sección para la suscripción del usuario (sólo para los dueños) -->
    <v-flex xs12 v-if="getProfile.user_type === 'owner'">
      <DeltiaCard>
        <!-- Subtítulo -->
        <v-col cols="12">
          <p class="font-weight-medium mb-1">
            Suscripción de Deltia
          </p>
        </v-col>
        <v-col cols="12" class="subtitle-1 mt-0 pt-0 mb-0 pb-0">
          Para manejar tu suscripción de Deltia puedes ir al portal de
          consumidores de Stripe con el siguiente botón
        </v-col>
        <!-- Portal del usuario -->
        <v-col cols="12" md="12" class="mt-4 mb-6 text-left">
          <v-btn
            rounded
            depressed
            color="primary"
            @click="redirectToCustomerPortal"
          >
            Manejar suscripción
          </v-btn>
        </v-col>
      </DeltiaCard>
    </v-flex>
  </v-container>
</template>

<script>
// Importar getters
import { mapGetters } from "vuex";

// Importar acciones
import { SIGN_OUT_REQUEST } from "@/store/actions/auth";

// Importar mixins
import taxSystems from "@/mixins/taxSystems";
import getStates from "@/mixins/states";

// Importar componentes
import DeltiaCard from "@/components/DeltiaCard";
import SnackbarMessage from "@/components/SnackbarMessage";

// Importar servicios
import SubscriptionServices from "@/services/SubscriptionServices";
import UsersServices from "@/services/UsersServices";
import BusinessServices from "@/services/BusinessServices";
import BillingService from "../../services/BillingService";

// Importar filtros
import { formatNumber } from "@/filters/numeral";

export default {
  name: "Settings",
  mixins: [taxSystems, getStates],
  data() {
    return {
      portalUrl: "",
      balance: null,
      pendingTotal: 0,
      availableTotal: 0,
      thankYouNote: "",
      newThankYouNote: "",
      billingForm: {
        name: "",
        legalName: "",
        taxSystem: "",
        address: {
          zip: "",
          street: "",
          exterior: "",
          interior: "",
          neighborhood: "",
          city: "",
          state: ""
        },
        website: "",
        supportEmail: "",
        phone: ""
      },
      isConfiguringBilling: false,
      billingInfo: null,
      billingCertForm: {
        cer: null,
        key: null,
        billingPassword: ""
      },
      isUploadingCert: false,
      isLoadingBilling: true
    };
  },
  filters: { formatNumber },
  components: {
    DeltiaCard,
    SnackbarMessage
  },
  mounted: async function() {
    // Verificar que el usuario es un dueño
    if (
      this.getProfile.user_type === "owner" &&
      !this.getProfile.stripe.pending_verification &&
      this.getProfile.stripe.details_submitted
    ) {
      // Obtener balance del usuario
      if (this.getProfile.testing_orders) {
        this.balance = await UsersServices.getBalance();

        // Realizar suma del balance pendiente
        this.pendingTotal = this.balance.pending[0].amount / 100;

        // Realizar suba del balance disponible
        this.availableTotal = this.balance.available[0].amount / 100;
      }
    }

    if (this.getProfile.user_type === "owner") {
      // Obtener portal del usuario
      // const session = await SubscriptionServices.getPortal();
      // this.portalUrl = session.url;

      // Obtener datos del negocio
      const business = await BusinessServices.getBusiness();
      this.thankYouNote = business.thank_you_note;
      this.newThankYouNote = business.thank_you_note;

      // Configurar datos de facturación
      this.billingForm.name = business.name;
      this.billingForm.phone = business.phone_number;
      this.billingForm.supportEmail = this.getProfile.email;

      // Obtener datos de facturación
      try {
        this.billingInfo = await BillingService.getBillingInfo();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log("DEBUG error=", error);
      } finally {
        this.isLoadingBilling = false;
      }
    }
  },
  methods: {
    signOut: function() {
      // Cerrar la sesión del usuario
      this.$store.dispatch(SIGN_OUT_REQUEST);

      // Pasar a la landing
      this.$router.replace({ name: "home" });
    },
    redirectToCustomerPortal: function() {
      window.location.href = this.portalUrl;
    },
    startOnboarding: async function() {
      const result = await UsersServices.startOnboarding();
      window.location.href = result.url;
    },
    updateThankYouNote: async function() {
      if (this.newThankYouNote !== this.thankYouNote) {
        await BusinessServices.updateThankYouNote(this.newThankYouNote);
      }
    },
    refresh: function() {
      this.$router.go();
    },
    configureBilling: async function() {
      this.isConfiguringBilling = true;
      await BillingService.configureBilling(this.billingForm);
      this.isConfiguringBilling = false;

      // Reload page
      this.$router.go();
    },
    uploadCert: async function() {
      try {
        this.isUploadingCert = true;

        // Crear formData
        const formData = new FormData();
        formData.append("cerFile", this.billingCertForm.cer);
        formData.append("keyFile", this.billingCertForm.key);
        formData.append(
          "billingPassword",
          this.billingCertForm.billingPassword
        );

        // Subir certificado
        await BillingService.uploadCert(formData);

        // Reload page
        this.$router.go();
      } catch (err) {
        // Mostrar error
        this.$refs.snackbar.showError(err.message);
      } finally {
        this.isUploadingCert = false;
      }
    }
  },
  computed: {
    ...mapGetters(["getProfile", "getBusiness"]),
    showBilling: function() {
      return (
        this.getProfile.user_type === "owner" &&
        this.getBusiness.is_billing_enabled === true &&
        !this.isLoadingBilling
      );
    },
    canConfigureBilling: function() {
      return (
        this.billingForm.name &&
        this.billingForm.legalName &&
        this.billingForm.taxSystem &&
        this.billingForm.address.zip &&
        this.billingForm.address.street &&
        this.billingForm.address.exterior &&
        this.billingForm.address.neighborhood &&
        this.billingForm.address.city &&
        this.billingForm.address.state &&
        this.billingForm.supportEmail &&
        this.billingForm.phone
      );
    }
  }
};
</script>
